import axios from "axios";

export default {
  add(evento) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .post("api/renta-bitacora", evento, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(evento) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .put(`api/renta-bitacora/${pago.eventoRentaId}`, evento, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  // delete (rentaId, numPago) {
  //     return axios.delete(`api/renta-pago/${rentaId}/${numPago}`, headerAuth)
  //         .then((result) => {
  //           return result.data;
  //         })
  //         .catch(e => {
  //         console.log(e);
  //         throw e;
  //         })
  // },

  getBitacora(rentaId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/renta-bitacora/${rentaId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  getBitacoraItem(rentaId, eventoRentaId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/renta-bitacora/${rentaId}/${eventoRentaId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
